/* Flooring Surgeons – About us showroom gallery: arrows, dots and a gentle 5s autoplay (like the old site) on a
   scroll-snap track. Autoplay stops for reduced motion, while hovered or focused, when off screen, and for good once
   the visitor uses the arrows or swipes. Dots are position indicators only (arrows are the 44px+ controls). Without JS the track is still a swipeable strip. */
(() => {
  if (customElements.get('fs-about-gallery')) return;
  customElements.define('fs-about-gallery', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.fs-ab-gal__track');
      this.slides = [...this.track.children];
      this.dots = [...this.querySelectorAll('[data-dot]')];
      if (this.slides.length < 2) return;
      this.i = 0;
      this.querySelector('[data-prev]')?.addEventListener('click', () => this.go(this.i - 1, true));
      this.querySelector('[data-next]')?.addEventListener('click', () => this.go(this.i + 1, true));
      let t;
      this.track.addEventListener('scroll', () => {
        clearTimeout(t);
        t = setTimeout(() => {
          const w = this.track.clientWidth || 1;
          this.i = Math.round(this.track.scrollLeft / w);
          this.mark();
        }, 60);
      }, { passive: true });
      this.track.addEventListener('pointerdown', () => this.stop(), { passive: true });
      this.track.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowRight') { e.preventDefault(); this.go(this.i + 1, true); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); this.go(this.i - 1, true); }
      });
      this.paused = false;
      ['pointerenter', 'focusin'].forEach((ev) => this.addEventListener(ev, () => (this.paused = true)));
      ['pointerleave', 'focusout'].forEach((ev) => this.addEventListener(ev, () => (this.paused = false)));
      this.visible = false;
      if ('IntersectionObserver' in window) new IntersectionObserver(([e]) => (this.visible = e.isIntersecting)).observe(this);
      if (!matchMedia('(prefers-reduced-motion: reduce)').matches) {
        this.timer = setInterval(() => { if (this.visible && !this.paused && !document.hidden) this.go(this.i + 1); }, 5000);
      }
    }
    disconnectedCallback() { this.stop(); }
    stop() { clearInterval(this.timer); this.timer = null; }
    go(n, user) {
      if (user) this.stop();
      const len = this.slides.length;
      this.i = (n + len) % len;
      const smooth = !matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.track.scrollTo({ left: this.i * this.track.clientWidth, behavior: smooth ? 'smooth' : 'auto' });
      this.mark();
    }
    mark() { this.dots.forEach((d, k) => d.setAttribute('aria-current', k === this.i ? 'true' : 'false')); }
  });
})();
